export default __webpack_public_path__ + "static/Ror_scrnsht_small-9d411652f16a11f632082abf6d947489.jpg";